export const IMAGE_TRANSFORM = 'fl_progressive,q_auto:eco,c_fill,w_220,h_140';
export const LONG_TEXT_LENGTH = 80;
export const UNCHANGED_SUMMARY = 'Unchanged';
export const REORDERED_SUMMARY = 'Reordered';

export const PREVIOUS_VALUE_KEY_ALIASES: Record<string, string> = {
  gallery: 'images',
};

export const EXPLICIT_FIELD_LABELS: Record<string, string> = {
  all_taxes_and_fees_as_non_commssionable: 'All taxes and fees non-commissionable',
  address: 'Street Address',
  category: 'Property Type / Category',
  commissionable_taxes_and_fees: 'Commissionable taxes and fees',
  include_tax_amount_into_before_amount: 'Include tax amount in before amount',
  location_heading: 'Location City',
  location_subheading: 'Location Country/State',
  logo_id_cloudinary_external: 'Logo',
  name: 'Property Name',
  taxes_and_fees: 'Taxes and fees',
  taxes_and_fees_content: 'Taxes and fees content',
  taxes_payable_at_property: 'Taxes payable at property',
};
